<template>
    <div class="tb_wrap">
        <div class="tb_box" id="todoTableDiv" style="width:100%; overflow-x:auto; height:700px;">
            <!-- 로딩 상태 -->
            <div v-if="isLoading" class="text-center p-4">
                <p>데이터를 불러오는 중...</p>
            </div>
            
            <!-- 에러 상태 -->
            <div v-else-if="error" class="text-center p-4 text-red-500">
                <p>{{ error }}</p>
                <vs-button 
                    color="primary" 
                    type="line" 
                    @click="$emit('retry')"
                    class="mt-2"
                >
                    다시 시도
                </vs-button>
            </div>
            
            <!-- 데이터 테이블 -->
            <table 
                v-else
                id="todoTable" 
                style="max-width:2200px; max-height:550px;" 
                class="border-collapse calendar"
            >
                <thead>
                    <tr class="fixed_top">
                        <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header" style="width:120px;">
                            작업
                        </th>
                        <th 
                            class="p-2 border border-solid d-theme-border-grey-light text-center table_header sortable" 
                            style="width:200px;" 
                            @click="$emit('sort', 'CS_DATE')"
                        >
                            등록시간
                            <span v-if="sortField === 'CS_DATE'" class="sort-indicator">
                                {{ sortDirection === 'ASC' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th 
                            class="p-2 border border-solid d-theme-border-grey-light text-center table_header sortable" 
                            style="width:100px;" 
                            @click="$emit('sort', 'MAIN_CS_USERNAME')"
                        >
                            상담 담당자
                            <span v-if="sortField === 'MAIN_CS_USERNAME'" class="sort-indicator">
                                {{ sortDirection === 'ASC' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th 
                            class="p-2 border border-solid d-theme-border-grey-light text-center table_header sortable" 
                            style="width:200px;" 
                            @click="$emit('sort', 'NEXT_DATE')"
                        >
                            리콜 예정일
                            <span v-if="sortField === 'NEXT_DATE'" class="sort-indicator">
                                {{ sortDirection === 'ASC' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th 
                            class="p-2 border border-solid d-theme-border-grey-light text-center table_header sortable" 
                            style="width:80px;" 
                            @click="$emit('sort', 'MEDICAL_ROOM_NUMBER_NM')"
                        >
                            호실
                        </th>
                        <th 
                            class="p-2 border border-solid d-theme-border-grey-light text-center table_header sortable" 
                            style="width:200px;" 
                            @click="$emit('sort', 'PATIENT_USERNAME')"
                        >
                            이름(나이,성별)<br/>/<br/>챠트번호
                        </th>
                        <th 
                            class="p-2 border border-solid d-theme-border-grey-light text-center table_header sortable" 
                            style="width:100px;" 
                            @click="$emit('sort', 'SICKNESS')"
                        >
                            진단명
                        </th>
                        <th 
                            class="p-2 border border-solid d-theme-border-grey-light text-center table_header sortable" 
                            style="width:100px;" 
                            @click="$emit('sort', 'IN_DATE')"
                        >
                            입원예정일
                        </th>
                        <th 
                            class="p-2 border border-solid d-theme-border-grey-light text-center table_header sortable" 
                            style="width:100px;" 
                            @click="$emit('sort', 'MAIN_CS_CALLER')"
                        >
                            주문의자
                        </th>
                        <th 
                            class="p-2 border border-solid d-theme-border-grey-light text-center table_header" 
                            style="width:150px;"
                        >
                            주문의자 연락처
                        </th>
                        <th 
                            class="p-2 border border-solid d-theme-border-grey-light text-center table_header" 
                            style="width:150px;"
                        >
                            상담메모s
                        </th>
                        <th 
                            class="p-2 border border-solid d-theme-border-grey-light text-center table_header" 
                            style="width:100px;"
                        >
                            상담메모
                        </th>
                        <th 
                            class="p-2 border border-solid d-theme-border-grey-light text-center table_header" 
                            style="width:570px;"
                        >
                            상담내역
                        </th>
                    </tr>
                </thead>

                <tbody>
                    <!-- 데이터 없음 -->
                    <tr v-if="!data || data.length === 0">
                        <td class="p-2 border border-solid d-theme-border-grey-light text-center" colspan="13ㄴ">
                            {{ isLoading ? '데이터를 불러오는 중...' : '등록된 상담내역이 존재하지 않습니다.' }}
                        </td>
                    </tr>
                    
                    <!-- 데이터 행 -->
                    <tr 
                        v-for="(item, index) in processedData" 
                        :key="`${item.PATIENT_UID}_${index}`"
                        :style="item.rowStyle"
                        class="data-row"
                    >
                        <td class="p-2 border border-solid d-theme-border-grey-light text-center">
                            <vs-row>
                                <vs-button 
                                    color="primary" 
                                    type="line" 
                                    icon-pack="feather" 
                                    icon="icon-edit-2" 
                                    @click="$emit('member-view', item.PATIENT_UID)"
                                    size="small"
                                />
                                <vs-button 
                                    color="primary" 
                                    type="line" 
                                    icon-pack="feather" 
                                    icon="icon-headphones" 
                                    @click="$emit('member-cs', item.PATIENT_UID)"
                                    size="small"
                                />
                            </vs-row>
                        </td>
                        <td class="p-2 border border-solid d-theme-border-grey-light text-center">
                            {{ item.CS_DATE }}
                        </td>
                        <td class="p-2 border border-solid d-theme-border-grey-light text-center">
                            {{ item.MAIN_CS_USERNAME }}
                        </td>
                        <td class="p-2 border border-solid d-theme-border-grey-light text-center">
                            <span :class="getDateStatusClass(item.NEXT_DATE)">
                                {{ item.NEXT_DATE }}
                            </span>
                        </td>
                        <td class="p-2 border border-solid d-theme-border-grey-light text-center">
                            {{ item.MEDICAL_ROOM_NUMBER_NM }}
                        </td>
                        <td class="p-2 border border-solid d-theme-border-grey-light text-center">
                            <div>{{ item.PATIENT_USERNAME }}({{ item.PATIENT_AGE }}, {{ item.PATIENT_GENDER }})</div>
                            <div class="text-sm text-gray-600">{{ item.CHART_NO }}</div>
                        </td>
                        <td class="p-2 border border-solid d-theme-border-grey-light text-center">
                            {{ item.SICKNESS }}
                        </td>
                        <td class="p-2 border border-solid d-theme-border-grey-light text-center">
                            {{ item.IN_DATE }}
                        </td>
                        <td class="p-2 border border-solid d-theme-border-grey-light text-center">
                            {{ item.MAIN_CS_CALLER }}
                        </td>
                        <td class="p-2 border border-solid d-theme-border-grey-light text-center">
                            {{ item.MAIN_CALLER_PHONE }}
                        </td>
                        <td class="p-2 border border-solid d-theme-border-grey-light text-left">
                            <div class="memo-cell">{{ item.CS2_MEMO }}</div>
                        </td>
                        <td class="p-2 border border-solid d-theme-border-grey-light text-left">
                            <div class="memo-cell">{{ item.CS_MEMO }}</div>
                        </td>
                        <td class="p-2 border border-solid d-theme-border-grey-light text-left">
                            <div class="content-cell">{{ item.CS_CONTENT }}</div>
                        </td>
                    </tr>
                </tbody>
            </table>
            
            <!-- 더 보기 버튼 제거됨 - 페이징으로만 이동 -->
        </div>
    </div>
</template>

<script>
export default {
    name: 'TodoTable',
    props: {
        data: {
            type: Array,
            default: () => []
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        isLoadingMore: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            default: null
        },
        sortField: {
            type: String,
            default: ''
        },
        sortDirection: {
            type: String,
            default: 'ASC'
        },
        tabType: {
            type: Number,
            default: 1
        }
    },
    emits: ['sort', 'member-view', 'member-cs', 'retry'],
    computed: {
        processedData() {
            if (!this.data) return [];
            
            return this.data.map(item => {
                const processedItem = { ...item };
                
                // 탭 타입에 따른 필터링 (백엔드에서 처리되므로 여기서는 스타일만)
                if (this.tabType === 1) {
                    // 리콜 Todo - 날짜에 따른 배경색
                    processedItem.rowStyle = this.getRowBackgroundStyle(item.NEXT_DATE);
                }
                
                return processedItem;
            });
        }
    },
    methods: {
        /**
         * 날짜 상태에 따른 CSS 클래스 반환
         */
        getDateStatusClass(date) {
            if (!date || date === '' || date === 'null') {
                return 'text-green-600 font-bold'; // 빈 날짜 - 녹색
            }
            
            const today = new Date();
            const targetDate = new Date(date);
            
            if (targetDate < today) {
                return 'text-red-600 font-bold'; // 과거 - 빨간색
            } else if (this.isSameDate(targetDate, today)) {
                return 'text-yellow-600 font-bold'; // 오늘 - 노란색
            } else {
                return 'text-blue-600 font-bold'; // 미래 - 파란색
            }
        },
        
        /**
         * 행의 배경색 스타일 반환 (리콜 Todo용)
         */
        getRowBackgroundStyle(nextDate) {
            if (!nextDate || nextDate === '' || nextDate === 'null') {
                return 'background-color: rgba(183,240,177, 0.3);'; // 빈 날짜 - 연한 녹색
            }
            
            const today = new Date();
            const targetDate = new Date(nextDate);
            
            if (targetDate < today) {
                return 'background-color: rgba(255,167,167, 0.3);'; // 과거 - 연한 빨간색
            } else if (this.isSameDate(targetDate, today)) {
                return 'background-color: rgba(250,237,125, 0.3);'; // 오늘 - 연한 노란색
            } else {
                return 'background-color: rgba(178,204,255, 0.3);'; // 미래 - 연한 파란색
            }
        },
        
        /**
         * 같은 날짜인지 확인
         */
        isSameDate(date1, date2) {
            return date1.getFullYear() === date2.getFullYear() &&
                   date1.getMonth() === date2.getMonth() &&
                   date1.getDate() === date2.getDate();
        }
    },
    mounted() {
        // 테이블 높이 동적 조정
        const adjustTableHeight = () => {
            const tableDiv = document.getElementById('todoTableDiv');
            if (tableDiv) {
                tableDiv.style.height = (document.documentElement.clientHeight - 400) + 'px';
            }
        };
        
        adjustTableHeight();
        window.addEventListener('resize', adjustTableHeight);
        
        // 컴포넌트 해제 시 이벤트 리스너 제거
        this.$once('hook:beforeDestroy', () => {
            window.removeEventListener('resize', adjustTableHeight);
        });
    }
};
</script>

<style scoped>
.table_header {
    position: sticky;
    top: 0;
    background-color: #f8f9fa;
    z-index: 10;
}

.sortable {
    cursor: pointer;
    user-select: none;
}

.sortable:hover {
    background-color: #e9ecef;
}

.sort-indicator {
    font-size: 12px;
    margin-left: 4px;
}

.data-row:hover {
    background-color: rgba(0, 123, 255, 0.1) !important;
}

.memo-cell {
    max-height: 60px;
    overflow-y: auto;
    word-wrap: break-word;
    white-space: pre-wrap;
}

.content-cell {
    max-height: 80px;
    overflow-y: auto;
    word-wrap: break-word;
    white-space: pre-wrap;
    line-height: 1.4;
}

.text-sm {
    font-size: 0.875rem;
}

.text-gray-600 {
    color: #6b7280;
}

.text-red-600 {
    color: #dc2626;
}

.text-green-600 {
    color: #16a34a;
}

.text-yellow-600 {
    color: #ca8a04;
}

.text-blue-600 {
    color: #2563eb;
}

.font-bold {
    font-weight: 700;
}
</style>